import type { ChatConversationItem, ChatMessageItem, ChatUnreadCountResponse } from '@ayub/shared'
import { apiGet, apiPost } from '@/lib/api'

/** `GET /api/chat/conversations` — suhbatlar ro'yxati (oxirgi xabar + o'qilmagan soni). */
export function fetchConversations(): Promise<ChatConversationItem[]> {
  return apiGet<ChatConversationItem[]>('/chat/conversations')
}

/** `GET /api/chat/:bloggerId/messages` — bitta suhbat tarixi (ochilganda o'qilgan deb belgilanadi). */
export function fetchChatMessages(bloggerId: number): Promise<ChatMessageItem[]> {
  return apiGet<ChatMessageItem[]>(`/chat/${bloggerId}/messages`)
}

/** `POST /api/chat/:bloggerId/messages` — admin xabari (bot orqali blogerga yetkaziladi). */
export function sendChatMessage(bloggerId: number, text: string): Promise<ChatMessageItem> {
  return apiPost<ChatMessageItem>(`/chat/${bloggerId}/messages`, { text })
}

/** `GET /api/chat/unread-count` — menyu belgisi uchun jami o'qilmagan. */
export function fetchUnreadCount(): Promise<ChatUnreadCountResponse> {
  return apiGet<ChatUnreadCountResponse>('/chat/unread-count')
}
